import { useMemo } from "react";

import { TableRow } from "@prequel/shared-components";

import { ApiRoutes } from "@/api/client";
import { useWebhooks } from "@/api/queries/webhooks";
import ResourceTable from "@/components/ResourceTable";
import Timestamp from "@/components/Timestamp";
import { DELIVERY_METHODS, ExistingWebhook } from "@/types";

const WEBHOOK_TABLE_COLUMNS = ["Webhook Name", "Delivery Method", "URL", "Events", "Created At"];

const rowMapper = (webhook: ExistingWebhook): TableRow => ({
  id: webhook.id,
  to: `${ApiRoutes.WEBHOOKS}/${webhook.id}`,
  cells: [
    { value: webhook.name },
    { value: DELIVERY_METHODS[webhook.vendor] || webhook.vendor },
    { value: webhook.url },
    { value: webhook.events.join(", ") },
    { value: <Timestamp timestamp={webhook.created_at} /> },
  ],
});

const rowComparator = (a: ExistingWebhook, b: ExistingWebhook) =>
  // sort by created_at in descending order
  new Date(b.created_at).getTime() - new Date(a.created_at).getTime();

const WebhooksTable = () => {
  const rowMapperMemo = useMemo(() => rowMapper, []);

  return (
    <ResourceTable<ExistingWebhook>
      columns={WEBHOOK_TABLE_COLUMNS}
      useQuery={useWebhooks}
      rowMapper={rowMapperMemo}
      rowComparator={rowComparator}
      emptyMessage="No webhooks found. Webhooks will show up here."
    />
  );
};

export default WebhooksTable;
